import { render, staticRenderFns } from "./EditOrganization.vue?vue&type=template&id=921f70cc&scoped=true&"
import script from "./EditOrganization.vue?vue&type=script&lang=js&"
export * from "./EditOrganization.vue?vue&type=script&lang=js&"
import style0 from "./EditOrganization.vue?vue&type=style&index=0&id=921f70cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921f70cc",
  null
  
)

export default component.exports